import React from 'react'
import { styled } from '@mui/material/styles'
import { Switch, SwitchProps } from '@mui/material'

/**
 * apps/dashboard's `IOSSwitch`, expressed with this app's CSS-variable tokens: a 38×22 pill,
 * an 18px white thumb, grey (shades-300) track when off and success-500 when on, no ripple.
 */
export const IOSSwitch = styled((props: SwitchProps) => {
  return <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
})(() => {
  return {
    width: 38,
    height: 22,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: 'var(--mui-shades-0)',
        '& + .MuiSwitch-track': {
          backgroundColor: 'var(--mui-success-500)',
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: 'var(--mui-success-500)',
        border: '6px solid var(--mui-shades-0)',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: 'var(--mui-shades-100)',
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.7,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 18,
      height: 18,
    },
    '& .MuiSwitch-track': {
      borderRadius: 22 / 2,
      backgroundColor: 'var(--mui-shades-300)',
      opacity: 1,
      transition: 'background-color 500ms',
    },
  }
})
